<template>
  <div class="company-date-news-dialog-box" @click.stop="cancel">
    <div class="company-date-news-dialog">
      <div class="dialog-header row">
        <div class="dialog-header-title">{{todayDate}}</div>
        <i @click="cancel" class="cancel-group-next"></i>
      </div>
      <div class="dialog-news-list" v-loading="isLoading">
        <div>
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="30"
          >
            <news-list-item
              v-for="(item, index) in resultData"
              :key="index"
              :data="item"
              :showClues="showClues"
              :appendToBody=true
              :modal=false
            ></news-list-item>
          </div>
        </div>
        <div class="loading" v-if="itemData.length && resultData.length && (totalCount>pageSize)">
          <div class="loading-word">加载中...</div>
        </div>
        <div class="loading" v-if="!itemData.length && resultData.length || (totalCount> 0 && totalCount<pageSize)">
          <div class="loading-word">没有更多了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsListItem from '@/components/news-monitor/NewsListItemV2';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      isLoading: false,
      itemData: [],
      resultData: [],
      dateRange: [],
      searchTextName: '',
      pageSize: 20,
      earliestNewsId: -1,
      earliestDateNum: -1,
      totalCount: 0,
      timer: null,
      busy: false,
      todayDate: '',
      showClues: true
    };
  },
  props: {
    chartCheckedDate: {
      type: Array
    },
    searchText: {
      type: String
    }
  },
  methods: {
    cancel(e) {
      if (
        e.target.className === 'company-date-news-dialog-box' || e.target.className === 'cancel-group-next'
      ) {
        this.$emit('closeTodayCompanyDialog');
      }
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        this.timer = setTimeout(() => {
          this.getNewsListV2();
        }, 500);
      }
    },
    getNewsListV2() {
      const params = {
        companies: [this.searchText],
        pageSize: this.pageSize,
        market: '全部',
        positive: [],
        negative: [],
        sourceGenre: '全部来源',
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        date: this.dateRange
      };
      this.isLoading = true;
      questionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.totalCount = res.totalCount;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    }
  },
  components: {
    NewsListItem
  },
  mounted() {
    this.dateRange = this.chartCheckedDate;
    this.todayDate = this.chartCheckedDate[0];
    this.searchTextName = this.searchText;
    this.getNewsListV2();
  }
};
</script>

<style lang="scss" scoped>
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 100%;
  color: #666666;
  text-align: center;
}
.company-date-news-dialog-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
}
.company-date-news-dialog {
  width: 810px;
  height: 554px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(247, 247, 250, 1);
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .dialog-header {
    justify-content: space-between;
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    color:rgba(23,31,70,1);
    font-weight:500;
    box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
    .dialog-header-title {
      color: #171f46;
      font-size: 14px;
    }
    .cancel-group-next {
      width: 16px;
      height: 16px;
      background-image: url("../../assets/img/close.svg");
      margin: 15px 24px;
      cursor: pointer;
    }
  }
  .dialog-news-list {
    padding: 0 32px;
    height: 500px;
    overflow: auto;
  }
}
</style>
